<template>
    <div class="begin_page" :style="{backgroundImage: 'url('+bgImage+')'}" style="height:100%;width: 100%;background-position: center top;background-repeat: no-repeat;background-size: cover;">
        <div v-if="!showVideo" class="begin_header" style="display: flex;justify-content: right;">
            <div style="display:flex;font-size: 20px;">
                <div v-for="(item, index) in titles" :key="index" @click="changeTitle(item)" style="margin-top:20px;margin-left:50px;cursor:pointer;">
                    {{item.name}}
                </div>
            </div>
        </div>
        <div v-if="!showVideo" style="margin-top: 300px;text-align:center;">
            <img style="width:500px;" src="../assets/biaoti.png" >
        </div>
        <div v-if="showVideo" style="width:80%;margin:0 auto;">
            <video-player style="width:100%;margin:0 auto;box-shadow:5px 5px 8px #888888"  class="video-player vjs-custom-skin"
                      ref="videoPlayer"
                      :playsinline="true"
                      @ended="onPlayerEnd($event)"
                      :options="playerOptions"
            ></video-player>
        </div>

        <el-dialog title="合格投资者认证" width="60%" top="10vh" :visible.sync="dialogVisible" :show-close="false" :close-on-click-modal="false" @before-close="reject" :center="true">
            <div class="hege" style="width:86%;margin:0 auto;text-align:justify;padding-left:5%;padding-bottom:10px;padding-right:5%;font-size:16px;line-height: 33px;height:450px;overflow-y:auto;">
                在继续浏览本公司网站前，请您确认您或您所代表的机构是一名“合格投资者”。根据我国《私募投资基金监督管理暂行办法》的规定，合格投资者的标准如下：
                <br/>
                一、私募基金的合格投资者是指具备相应风险识别能力和风险承担能力，投资于单只私募基金的金额不低于100万元
                且符合下列相关标准的单位和个人：
                <br/>
                1、净资产不低于1000万元的单位；
                <br/>
                2、金融资产不低于300万元或者最近三年个人年均收入不低于50万元的个人。前款所称金融资产包括银行存款、
                股票、债券、基金份额、资产管理计划、银行理财产品、信托计划、保险产品、期货权益等。
                <br/>
                二、下列投资者视为合格投资者：
                <br/>
                1、社会保障基金、企业年金等养老基金、慈善基金等社会公益基金；
                <br/>
                2、依法设立并在基金业协会备案的投资计划；
                <br/>
                3、投资于所管理私募基金的私募基金管理人及其从业人员；
                <br/>
                4、中国证监会规定的其他投资者。
                <br/>
                如果您继续访问或使用本网站及其所载资料，即表明您声明及保证您或您所代表的机构为“合格投资者”，并将遵守对您适用的司法区域的有关法律及法规，同意并接受以下条款及相关约束。如果您不符合“合格投资者”标准或不同意下列条款及相关约束，请勿继续访问或使用本网站及其所载信息及资料。
                <br/>
                投资涉及风险，投资者应详细审阅产品的发售文件以获取进一步资料，了解有关投资所涉及的风险因素，并寻求适当的专业投资和咨询意见。产品净值及其收益存在涨跌可能，过往的产品业绩数据并不预示产品未来的业绩表现。本网站所提供的资料并非投资建议或咨询意见，投资者不应依赖本网站所提供的信息及资料作出投资决策。
                <br/>
                与本网站所载信息及资料有关的所有版权、专利权、知识产权及其他产权均为本公司所有。本公司概不向浏览该资料人士发出、转让或以任何方式转移任何种类的权利。
            </div>
            <div style="width:86%;margin:0 auto;border-bottom:1px solid #cccccc;padding-top:30px;">

            </div>
            <div slot="footer" class="dialog-footer" style="font-size: 18px;cursor: pointer;">
                <div style="margin: 0 auto;width: 176px;height:50px;border-radius:25px;border:1px solid #d0f4ff;justify-content: center;display: flex;align-items: center;">
                    <div @click="accept" style="font-size:17px;font-weight:600;text-align:center;border-radius:21px;background:#3fa8c7;color:#ffffff;width:160px;height:42px;line-height:42px;cursor:pointer;">接 受
                    </div>
                </div>
                <div style="margin: 0 auto;margin-top:15px;border-bottom:2px solid #8e8686;color: #858282;padding-bottom:3px;width:50px;margin-bottom:10px;" @click="reject">放 弃</div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        name: 'Index',
        data() {
            return {
                sliders: [],
                dialogVisible: false,
                showVideo: false,
                playerOptions : {
                    playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                    autoplay: true, //如果true,浏览器准备好时开始回放。
                    muted: false, // 默认情况下将会消除任何音频。
                    loop: false, // 导致视频一结束就重新开始。
                    preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    language: 'zh-CN',
                    aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    sources: [{
                        src: 'https://hhhsdemo.oss-cn-shanghai.aliyuncs.com/website/shipin.mp4', // require('../assets/shipin.mp4'), // 'http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4',  // 路径
                        // type: 'video/mp4'  // 类型
                        type: "video/mp4",
                    }],
                    controls: false,
                    poster: "封面路径", //你的封面地址
                    // width: document.documentElement.clientWidth,
                    notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    controlBar: {
                        timeDivider: true,
                        durationDisplay: true,
                        remainingTimeDisplay: false,
                        fullscreenToggle: true  //全屏按钮
                    }
                },
                videoPlay: false,
                // playerOptions: {
                //     height: '360',
                //     sources: [{
                //         type: "rtmp/mp4",
                //         src: "rtmp://184.72.239.149/vod/&mp4:BigBuckBunny_115k.mov"
                //     }],
                //     techOrder: ['flash'],
                //     autoplay: false,
                //     controls: true,
                //     poster: "https://surmon-china.github.io/vue-quill-editor/static/images/surmon-9.jpg"
                // },
                bgImage: require('../assets/beijing.png'),
                titles: [{
                    name: '首页',
                    value: '/index'
                }, {
                    name: '走进汇升',
                    value: '/enterHS'
                }, {
                    name: '汇升文化',
                    value: '/hsCulture'
                }, {
                    name: '汇升投教',
                    value: '/hsInvestEducation'
                }, {
                    name: '汇升招聘',
                    value: '/hsEngage'
                }],
                carousel_height: '550px',
            }
        },
        methods: {
            changeTitle(item) {
                this.$router.push({
                    path: item.value,
                    // query: {
                    //     id: this.roleId,
                    //     ids: this.checkList
                    // }
                })
            },
            accept() {
                this.$router.push({
                    path: '/index',
                })
                setTimeout(function () {
                    window.location.reload();
                }, 1);
                // this.dialogVisible = false
                // this.showVideo = true
                // this.videoPlay = true
            },
            reject() {
                this.dialogVisible = false
                setTimeout(() => {
                    this.dialogVisible = true
                }, 600)
            },
            // // 准备好了
            // onPlayerReady(v) {
            //     console.log(1)
            //     console.log(v)
            // },
            // // 播放了
            // onPlayerPlay(v) {
            //     console.log(2)
            //     console.log(v)
            // },
            // // 暂停了
            // onPlayerPause(v) {
            //     console.log(3)
            //     console.log(v)
            // },
            // // 播放结束了
            onPlayerEnd() {
                this.showVideo = false
                // console.log(4)
                // console.log(v)
            }
        },
        mounted() {
            // this.sliders = [
            //     {
            //         img: require("../../static/slider/a1.jpg")
            //     },
            //     {
            //         img: require("../../static/slider/a2.jpg")
            //     },
            //     {
            //         img: require('../../static/slider/a3.jpg')
            //     },
            //     {
            //         img: require('../../static/slider/a4.jpg')
            //     }
            // ]
            setTimeout(() => {
                this.dialogVisible = true
            }, 100)
        },
        computed: {
            //计算高度
            computeHeight() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 415) {
                    return '550px';
                } else {
                    return '250px';
                }
            },
        },
    }
</script>
<style>
.begin_page .el-dialog__title {
    font-size: 30px;
}
.begin_page .el-dialog__header {
    padding-top: 28px;
}
.begin_page .el-dialog__body {
    font-size: 16px;
}
.video-player {
    box-shadow: none !important;
}
.video-js {
    background-color: #ffffff !important;
}
</style>
<style scoped>
    .hege::-webkit-scrollbar {
        width: 4px;
        background: #f2f3f5;
    }
    ::-webkit-scrollbar-thumb  
    { 
        
        border-radius: 3px;
        background: #d8d8d8;
    } 
    .begin_header{
        margin: auto;
        width: 80%;
        height: 80px;
        padding-top: 20px;
        /*background: #F56C6C;*/
    }
    .logo_img{
        float:left;
        width: 30%;
        cursor: pointer;
    }
    #back_to_top{
        position: fixed;
        bottom: 50px;
        right: 30px;
        cursor: pointer
    }
    .company_name{
        font-weight: normal;
        font-size: 1em;
    }
    .header-title{
        font-size: 1em;
    }
    #header-img{
        width: 50px;
        height: 50px;
        float: left;
        margin: auto;
    }
    .header-logo{
        height: 50px;
        width: 50px;
        align-self: center;
    }
    .header-important{
        float: left;
        margin-left: 6px;
        align-self: center;
    }

    #player{
        width: 1000px;
        height: 500px;
        margin: 0 auto;
    }
</style>


// WEBPACK FOOTER //
// src/components/begin.vue